import React, { useEffect, useRef, useState } from 'react'
import { makeStyles } from 'tss-react/mui'
import theme from 'ui/theme'
import { Paper } from '@mui/material'

const useStyles = makeStyles()((theme) => ({
  children: {
    overflowY: 'auto',
    maxHeight: `calc(100vh - ${theme.spacing(12)})`,
  },
  fixedContent: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    flex: 1,
  },
  header: {
    borderTopRightRadius: theme.spacing(0.5),
    borderTopLeftRadius: theme.spacing(0.5),
  },
  footer: {
    borderBottomRightRadius: theme.spacing(0.5),
    borderBottomLeftRadius: theme.spacing(0.5),
  },
}))

export type ContentScrollProps = {
  children: any
  /**
   * 固定ヘッダコンテンツ
   */
  header?: any
  /**
   * 固定フッタコンテンツ
   */
  footer?: any
}

const ModalScrollContent: React.FC<ContentScrollProps> = ({
  children,
  header,
  footer,
}: ContentScrollProps) => {
  const { classes, cx } = useStyles()

  const headerRef = useRef<HTMLDivElement>(null)
  const footerRef = useRef<HTMLDivElement>(null)

  const [contentMaxHeight, setContentMaxHeight] = useState<string>()

  useEffect(() => {
    const height =
      (headerRef.current?.clientHeight || 0) +
      (footerRef.current?.clientHeight || 0)
    setContentMaxHeight(
      `calc(100vh - ${height + Number(theme.spacing(12).slice(0, -2))}px)`
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [children, headerRef.current, footerRef.current])

  return (
    <Paper>
      {header && (
        <div
          ref={headerRef}
          className={cx(classes.fixedContent, classes.header)}
        >
          {header}
        </div>
      )}
      <div
        className={classes.children}
        style={contentMaxHeight ? { maxHeight: contentMaxHeight } : undefined}
      >
        {children}
      </div>
      {footer && (
        <div
          ref={footerRef}
          className={cx(classes.fixedContent, classes.footer)}
        >
          {footer}
        </div>
      )}
    </Paper>
  )
}

export default ModalScrollContent
